import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Icon from "@/v2-ui/icon"
import type { UserStatusFragment } from "@/v2-backoffice-client/user/status/__types__/user.status.fragment"
import { getUserStatusStyle } from "@/v2-backoffice-client/user/status/userStatus.constants"

export type UserStatusBadgeProps = ComponentProps<"span"> & {
  status: UserStatusFragment
}

function UserStatusBadge(props: UserStatusBadgeProps) {
  const { status, className, ...spanProps } = props
  const style = getUserStatusStyle(status.Code)

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 text-xs text-muted-foreground",
        className,
      )}
      {...spanProps}
    >
      <Icon
        className={`shrink-0 ${style.iconColor}`}
        src={style.iconSrc}
        size={14}
      />
      {status.Name}
    </span>
  )
}

export default UserStatusBadge
